export default "__VITE_ASSET__DMJfA50d__"